import PokerTableBaseModel from "../../../table/module/poker_table/poker_table_base_model";
import NetMessageDataBiPaiGame from "../../net/bipai_net_msg_data_game";
import { BiPaiGame } from "../../net/proto/bipai_game";

const { ccclass, property } = cc._decorator;


@ccclass
export default class BiPaiTableModelBase extends PokerTableBaseModel {    

    send_ack_req(ackId: number){
        let protoData: BiPaiGame.IAckReq = {
            ackId: ackId,
        }
        this.sendMsg(NetMessageDataBiPaiGame.AckReq, protoData)
    }

}